import linkedin from "../images/contact/linkedin.svg";
import gmail from "../images/contact/gmail.svg";
import github from "../images/contact/github.svg";

// **************************
// social icons
// **************************
export const socialIcons = [
  {
    id: 1,
    icon: gmail,
    url: "mailto:nkenguestephane0@gmail.com",
    title: "Gmail",
  },
  {
    id: 2,
    icon: linkedin,
    url: "https://www.linkedin.com/in/stephane-nkengue-4bb27b242/",
    title: "LinkedIn",
  },
  {
    id: 3,
    icon: github,
    url: "https://github.com/StephaneNkengue",
    title: "GitHub",
  },
];

// Les liens de navigation vivent désormais dans NavLinks.js : leurs libellés
// dépendent de la langue et viennent de src/data/translations.js.
